export const countries: { id: string; text: string }[] = [
  { id: 'AU', text: 'Australia' },
  { id: 'AT', text: 'Austria' },
  { id: 'BE', text: 'Belgium' },
  { id: 'BR', text: 'Brazil' },
  { id: 'CA', text: 'Canada' },
  { id: 'CN', text: 'China' },
  { id: 'DK', text: 'Denmark' },
  { id: 'FI', text: 'Finland' },
  { id: 'FR', text: 'France' },
  { id: 'DE', text: 'Germany' },
  { id: 'HK', text: 'Hong Kong' },
  { id: 'IE', text: 'Ireland' },
  { id: 'IT', text: 'Italy' },
  { id: 'JP', text: 'Japan' },
  { id: 'LU', text: 'Luxembourg' },
  { id: 'MY', text: 'Malaysia' },
  { id: 'MX', text: 'Mexico' },
  { id: 'NL', text: 'Netherlands' },
  { id: 'NZ', text: 'New Zealand' },
  { id: 'NO', text: 'Norway' },
  { id: 'PT', text: 'Portugal' },
  { id: 'SG', text: 'Singapore' },
  { id: 'ES', text: 'Spain' },
  { id: 'SE', text: 'Sweden' },
  { id: 'CH', text: 'Switzerland' },
  { id: 'GB', text: 'United Kingdom' },
  { id: 'US', text: 'United States' },
];

export const defaultValues = {
  cardNumber: '',
  cardExpiry: '',
  cardCvc: '',
  line1: '',
  line2: '',
  city: '',
  state: '',
  name: '',
  country: '',
  postal_code: '',
};

export const cardNumber = 'cardNumber';
export const cardExpiry = 'cardExpiry';
export const cardCvc = 'cardCvc';

export const inputAttributes = { maxLength: 255 };
export const requiredMessage = 'This field is required';
